import Styles from './ChooseMedia.module.scss'
import { ImageButtons } from '../ImageButtons/ImageButtons'
import { MediaCarousels } from '../MediaCarousels'
import { ChooseMediaProps } from '../Types'

export const ChooseMedia = ({ altButton, accept }: ChooseMediaProps) => {
  return (
    <div className={Styles.content}>
      <div className={Styles.upperSection}>
        <ImageButtons accept={accept} />
        {!!altButton && altButton}
      </div>
      <MediaCarousels accept={accept} />
    </div>
  )
}
